import readToolName from '../utils/readToolName';
import AiChatMarkdown from './AiChatMarkdown';
import AiChatReasoning from './AiChatReasoning';
import AiChatToolCall from './AiChatToolCall';

import type { ReactElement } from 'react';
import type IAiChatPart from '../interfaces/IAiChatPart';

/**
 * One part of a message, rendered by its type.
 *
 * A part type this UI does not know yet renders nothing rather than raw JSON: the API stores the
 * whole AI SDK part union, so a file or a source can appear here at any time.
 */
function AiChatPart({ part }: IAiChatPart): ReactElement | null {
  if (part.type === 'text') {
    return part.text ? (
      <AiChatMarkdown text={part.text} isStreaming={part.state === 'streaming'} />
    ) : null;
  }

  if (part.type === 'reasoning') {
    return part.text ? (
      <AiChatReasoning text={part.text} isStreaming={part.state === 'streaming'} />
    ) : null;
  }

  // Boundary between two steps of the same reply. Hidden when it opens the message.
  if (part.type === 'step-start') {
    return null;
  }

  const toolName = readToolName(part);

  // Every tool the model calls is listed, named or not, so no step of a reply goes unshown.
  if (toolName !== null) {
    return <AiChatToolCall part={part} name={toolName} />;
  }

  return null;
}

export default AiChatPart;
